import { moduleLastMidPref } from '@syscolect/domain'
import { preferencesService } from '@/services/preferences.bootstrap'

export function getPersistedMid(slug: string): string | null {
  return preferencesService.get(moduleLastMidPref(slug))
}

export function persistMid(slug: string, mid: string): void {
  preferencesService.set(moduleLastMidPref(slug), mid)
}
